<div class="container">
  <div class="form-signin text-center">
    <img class="mb-4 mb-50" src="../../../assets/images/logo_pad.svg" alt="" width="280">
    <h1 class="h4 mb-4 mb-50 fw-light">Bienvenido a Aeroplantas YPF.</h1>
    <a class="btn btn-lg btn-primary btn-block rounded"(click)="login()" id="loginButton">Iniciar sesión</a>
    <p class="mt-5 mb-10 text-muted"></p>
    <img class=" mt-4" src="../../../assets/images/logo_aoniken.svg" alt="" width="150">
  </div>
</div>